module.exports = __webpack_public_path__ + "static/media/logo.bb4c6d19.png";